// Bilingual solution catalogue. All copy follows the approved Bula Telecoms narrative:
// availability is always subject to feasibility, coverage, regulation and contract.
export const SOLUTIONS = [
  {
    slug: "fibre-optique",
    icon: "Cable",
    fr: {
      title: "Fibre optique FTTH, FTTB & FTTx",
      short: "Connectivité très haut débit pour les foyers, immeubles, entreprises, campus et institutions, déployée à partir de réseaux métropolitains et d'architectures évolutives.",
      outcome: "Une connectivité stable et très haut débit qui accompagne la croissance de votre foyer, de votre entreprise ou de votre institution.",
      overview: "Bula Telecoms conçoit et déploie des réseaux fibre pour les foyers, immeubles, entreprises, institutions, campus et projets immobiliers. Nos architectures sont pensées pour offrir performance, stabilité et capacité d'évolution.",
      capabilities: [
        "FTTH : fibre jusqu'au domicile", "FTTB : fibre jusqu'à l'immeuble ou l'entreprise",
        "FTTP et autres architectures FTTx", "Anneaux fibre métropolitains",
        "Liaisons entreprise dédiées", "Réseaux d'immeubles et de campus",
        "Tests, mise en service et maintenance", "Soudure par fusion fibre monomode et multimode",
        "Tests optiques OTDR adaptés", "Maintenance préventive et corrective",
      ],
      useCases: ["Connecter une résidence ou un immeuble en très haut débit", "Relier un siège et ses annexes par fibre dédiée", "Équiper un campus ou un projet immobilier en fibre-ready"],
      segments: ["Particuliers & résidences", "Entreprises", "Promoteurs immobiliers", "Institutions"],
      benefits: ["Très haut débit symétrique selon l'offre", "Stabilité et faible latence", "Architecture évolutive", "Maintenance par des équipes locales"],
      faq: [
        { q: "La fibre est-elle disponible à mon adresse ?", a: "La disponibilité dépend de la couverture et d'une étude de faisabilité. Utilisez notre vérification de couverture : notre équipe analysera les options pour votre adresse." },
        { q: "Quelle différence entre FTTH et FTTB ?", a: "FTTH amène la fibre jusqu'au domicile ; FTTB l'amène jusqu'à l'immeuble ou l'entreprise, la distribution finale s'effectuant au sein du bâtiment." },
      ],
    },
    en: {
      title: "Fibre optic FTTH, FTTB & FTTx",
      short: "Very-high-speed connectivity for homes, buildings, businesses, campuses and institutions, deployed from metropolitan networks and scalable architectures.",
      outcome: "Stable, very-high-speed connectivity that grows with your household, business or institution.",
      overview: "Bula Telecoms designs and deploys fibre networks for homes, buildings, businesses, institutions, campuses and property developments. Our architectures are built for performance, stability and scalability.",
      capabilities: [
        "FTTH: fibre to the home", "FTTB: fibre to the building or business",
        "FTTP and other FTTx architectures", "Metropolitan fibre rings",
        "Dedicated enterprise links", "Building and campus networks",
        "Testing, commissioning and maintenance", "Fusion splicing for single-mode and multimode fibre",
        "Appropriate OTDR optical testing", "Preventive and corrective maintenance",
      ],
      useCases: ["Connect a residence or building at very high speed", "Link a head office and its annexes over dedicated fibre", "Equip a campus or property development as fibre-ready"],
      segments: ["Households & residences", "Businesses", "Property developers", "Institutions"],
      benefits: ["Symmetrical very high speed depending on the offer", "Stability and low latency", "Scalable architecture", "Maintenance by local teams"],
      faq: [
        { q: "Is fibre available at my address?", a: "Availability depends on coverage and a feasibility study. Use our coverage check: our team will assess the options for your address." },
        { q: "What is the difference between FTTH and FTTB?", a: "FTTH brings fibre to the home; FTTB brings it to the building or business, with final distribution inside the premises." },
      ],
    },
  },
  {
    slug: "internet-fixe-sans-fil",
    icon: "Radio",
    fr: {
      title: "Internet fixe sans fil P2P & P2MP",
      short: "Liaisons P2P et P2MP de qualité opérateur permettant de connecter rapidement des résidences, entreprises et sites difficiles à desservir par fibre.",
      outcome: "Une connexion rapide à déployer, sans attendre l'arrivée de la fibre sur votre site.",
      overview: "Nos solutions sans fil permettent de connecter rapidement des sites lorsque le déploiement immédiat de fibre n'est pas possible ou économiquement pertinent. Elles répondent aux besoins des résidences, entreprises, institutions et sites distants.",
      capabilities: [
        "Liaisons point-à-point (P2P) longue portée", "Distribution point-multipoint (P2MP)",
        "Déploiement rapide sans génie civil lourd", "Qualité de service de classe opérateur",
        "Débits pouvant atteindre 1 Gbps selon l'étude de faisabilité, la technologie, la visibilité radio, la réglementation et la configuration retenue",
      ],
      useCases: ["Connecter un site en attente de fibre", "Desservir une zone périurbaine", "Relier deux bâtiments sans travaux"],
      segments: ["Particuliers & résidences", "Entreprises", "Institutions", "Sites distants"],
      benefits: ["Mise en service rapide", "Coût maîtrisé", "Évolutivité vers la fibre", "Couverture des zones difficiles"],
      faq: [
        { q: "Quels débits puis-je espérer ?", a: "Les débits peuvent atteindre 1 Gbps selon l'étude de faisabilité, la technologie, la visibilité radio, la réglementation et la configuration retenue." },
        { q: "Faut-il une visibilité directe ?", a: "Une étude radio détermine la faisabilité ; la visibilité entre les points influe sur les performances." },
      ],
    },
    en: {
      title: "Fixed wireless Internet P2P & P2MP",
      short: "Carrier-grade P2P and P2MP links to quickly connect residences, businesses and sites that are hard to serve by fibre.",
      outcome: "A fast-to-deploy connection, without waiting for fibre to reach your site.",
      overview: "Our wireless solutions connect sites quickly when immediate fibre deployment is not possible or economically relevant. They serve residences, businesses, institutions and remote sites.",
      capabilities: [
        "Long-range point-to-point (P2P) links", "Point-to-multipoint (P2MP) distribution",
        "Rapid deployment without heavy civil works", "Carrier-grade quality of service",
        "Speeds of up to 1 Gbps subject to the feasibility study, technology, radio line of sight, regulation and selected configuration",
      ],
      useCases: ["Connect a site awaiting fibre", "Serve a peri-urban area", "Link two buildings without civil works"],
      segments: ["Households & residences", "Businesses", "Institutions", "Remote sites"],
      benefits: ["Rapid commissioning", "Controlled cost", "Upgrade path to fibre", "Coverage of hard-to-reach areas"],
      faq: [
        { q: "What speeds can I expect?", a: "Speeds can reach 1 Gbps depending on the feasibility study, technology, radio line of sight, regulation and selected configuration." },
        { q: "Is direct line of sight required?", a: "A radio survey determines feasibility; visibility between points affects performance." },
      ],
    },
  },
  {
    slug: "internet-satellite",
    icon: "Satellite",
    fr: {
      title: "Connectivité satellite pour les sites difficiles d'accès",
      short: "Solutions satellitaires LEO et VSAT pour les zones éloignées, les sites isolés, les opérations critiques et les déploiements nécessitant une couverture rapide.",
      outcome: "Une connectivité là où aucune infrastructure terrestre n'arrive encore.",
      overview: "Bula Telecoms intègre des solutions satellitaires LEO et VSAT sur différentes bandes afin de connecter les zones éloignées, les opérations temporaires, les sites industriels, les communautés rurales et les infrastructures critiques. Les solutions satellite dépendent de la couverture, des autorisations et des conditions d'exploitation locales.",
      capabilities: [
        "Solutions LEO nouvelle génération", "VSAT multi-bandes selon les zones",
        "Kits de déploiement rapide", "Connectivité de secours (backup)",
        "Intégration avec les réseaux locaux du site",
      ],
      useCases: ["Communautés rurales", "Mines et sites industriels", "Agriculture", "Écoles et centres de santé", "Reprise après sinistre", "Chantiers", "Postes administratifs éloignés", "Connectivité de secours"],
      segments: ["Zones rurales", "Industries & mines", "Institutions", "Secteur public"],
      benefits: ["Couverture quasi universelle selon la constellation", "Déploiement rapide", "Solution de secours crédible", "Adaptée aux sites isolés"],
      faq: [
        { q: "Le satellite fonctionne-t-il partout ?", a: "Les solutions satellite dépendent de la couverture de la constellation, des autorisations réglementaires et des conditions locales d'exploitation. Nous étudions chaque site." },
      ],
    },
    en: {
      title: "Satellite connectivity for hard-to-reach sites",
      short: "LEO and VSAT satellite solutions for remote areas, isolated sites, critical operations and deployments requiring rapid coverage.",
      outcome: "Connectivity where no terrestrial infrastructure has arrived yet.",
      overview: "Bula Telecoms integrates LEO and VSAT satellite solutions across multiple bands to connect remote areas, temporary operations, industrial sites, rural communities and critical infrastructure. Satellite solutions depend on coverage, authorisations and local operating conditions.",
      capabilities: [
        "New-generation LEO solutions", "Multi-band VSAT depending on the area",
        "Rapid-deployment kits", "Backup connectivity",
        "Integration with on-site local networks",
      ],
      useCases: ["Rural communities", "Mines and industrial sites", "Agriculture", "Schools and health centres", "Disaster recovery", "Construction sites", "Remote government outposts", "Backup connectivity"],
      segments: ["Rural areas", "Industry & mining", "Institutions", "Public sector"],
      benefits: ["Near-universal coverage depending on the constellation", "Rapid deployment", "Credible backup solution", "Suited to isolated sites"],
      faq: [
        { q: "Does satellite work everywhere?", a: "Satellite solutions depend on constellation coverage, regulatory authorisations and local operating conditions. We assess each site individually." },
      ],
    },
  },
  {
    slug: "ip-transit-dia",
    icon: "Globe",
    fr: {
      title: "IP Transit, DIA et capacité de gros",
      short: "Capacité Internet dédiée et évolutive pour opérateurs, fournisseurs d'accès, entreprises et organisations exigeant performance, disponibilité et maîtrise de leur connectivité.",
      outcome: "Une capacité Internet maîtrisée, évolutive et résiliente pour vos services critiques.",
      overview: "Nous fournissons aux opérateurs, FAI, entreprises et grandes institutions une capacité Internet évolutive, conçue pour soutenir la performance, la croissance du trafic et la continuité des services.",
      capabilities: [
        "IP Transit", "Direct Internet Access (DIA)", "Capacité de gros (wholesale)",
        "Peering et échange de trafic", "Optimisation des routes",
        "Architecture amont redondante", "Préparation IPv4 et IPv6",
        "Accompagnement à la configuration BGP",
        "Architecture optionnelle de sécurité et protection DDoS lorsque contractuellement disponible",
        "Capacité évolutive jusqu'à 100 Gbps, selon la conception technique et le contrat",
      ],
      useCases: ["Fournir du transit à un FAI régional", "Connecter un siège avec une DIA garantie", "Sécuriser la croissance de trafic d'une plateforme"],
      segments: ["Opérateurs & FAI", "Grandes entreprises", "Institutions financières", "Secteur public"],
      benefits: ["Capacité évolutive", "Routes optimisées", "Architecture redondante", "Support BGP"],
      faq: [
        { q: "Quelle capacité maximale ?", a: "La capacité peut monter jusqu'à 100 Gbps, selon la conception technique et le contrat." },
        { q: "Proposez-vous de la protection DDoS ?", a: "Une architecture de sécurité et de protection DDoS peut être proposée lorsqu'elle est contractuellement disponible." },
      ],
      ctaLabel: "Demander une étude de capacité",
    },
    en: {
      title: "IP Transit, DIA and wholesale capacity",
      short: "Dedicated, scalable Internet capacity for operators, ISPs, businesses and organisations demanding performance, availability and control of their connectivity.",
      outcome: "Controlled, scalable and resilient Internet capacity for your critical services.",
      overview: "We provide operators, ISPs, enterprises and large institutions with scalable Internet capacity designed to support performance, traffic growth and service continuity.",
      capabilities: [
        "IP Transit", "Direct Internet Access (DIA)", "Wholesale capacity",
        "Peering and traffic exchange", "Route optimisation",
        "Redundant upstream architecture", "IPv4 and IPv6 readiness",
        "BGP configuration support",
        "Optional security and DDoS-protection architecture where contractually available",
        "Capacity scaling up to 100 Gbps, subject to technical design and contract",
      ],
      useCases: ["Supply transit to a regional ISP", "Connect a head office with guaranteed DIA", "Secure a platform's traffic growth"],
      segments: ["Operators & ISPs", "Large enterprises", "Financial institutions", "Public sector"],
      benefits: ["Scalable capacity", "Optimised routes", "Redundant architecture", "BGP support"],
      faq: [
        { q: "What is the maximum capacity?", a: "Capacity can scale up to 100 Gbps, subject to technical design and contract." },
        { q: "Do you offer DDoS protection?", a: "A security and DDoS-protection architecture can be offered where contractually available." },
      ],
      ctaLabel: "Request a capacity study",
    },
  },
  {
    slug: "sd-wan-mpls",
    icon: "Network",
    fr: {
      title: "SD-WAN & MPLS — Connectez et sécurisez tous vos sites",
      short: "Interconnexion sécurisée des sièges, agences, succursales et sites distants au sein d'un environnement unifié et administrable.",
      outcome: "Un réseau d'entreprise unifié, sécurisé et pilotable, quel que soit le nombre de sites.",
      overview: "Nos solutions SD-WAN, MPLS et VPN permettent aux entreprises et institutions de relier leurs sièges, agences, succursales et sites distants au sein d'un environnement de communication sécurisé, unifié et administrable.",
      capabilities: [
        "Interconnexion multi-sites MPLS/VPN", "SD-WAN avec pilotage centralisé",
        "Priorisation du trafic applicatif", "Chiffrement et segmentation",
        "Supervision et rapports", "Hybridation fibre / sans fil / satellite",
      ],
      useCases: ["Relier des agences bancaires", "Unifier le réseau d'un groupe multisite", "Connecter des sites distants au siège"],
      segments: ["Banques & assurances", "Groupes multisites", "Industries", "Institutions"],
      benefits: ["Vision centralisée", "Sécurité renforcée", "Performance applicative", "Flexibilité multi-technologie"],
      faq: [
        { q: "SD-WAN ou MPLS : que choisir ?", a: "Tout dépend de vos contraintes de performance, de sécurité et de budget. Nous concevons l'architecture adaptée, parfois hybride." },
      ],
    },
    en: {
      title: "SD-WAN & MPLS — Connect and secure all your sites",
      short: "Secure interconnection of head offices, branches and remote sites within a unified, manageable environment.",
      outcome: "A unified, secure and manageable enterprise network, however many sites you operate.",
      overview: "Our SD-WAN, MPLS and VPN solutions enable businesses and institutions to connect their head offices, branches and remote sites within a secure, unified and manageable communication environment.",
      capabilities: [
        "Multi-site MPLS/VPN interconnection", "SD-WAN with centralised control",
        "Application traffic prioritisation", "Encryption and segmentation",
        "Monitoring and reporting", "Hybrid fibre / wireless / satellite underlay",
      ],
      useCases: ["Connect bank branches", "Unify a multi-site group's network", "Link remote sites to headquarters"],
      segments: ["Banking & insurance", "Multi-site groups", "Industry", "Institutions"],
      benefits: ["Centralised visibility", "Enhanced security", "Application performance", "Multi-technology flexibility"],
      faq: [
        { q: "SD-WAN or MPLS: which should I choose?", a: "It depends on your performance, security and budget constraints. We design the right architecture — sometimes a hybrid one." },
      ],
    },
  },
  {
    slug: "securite-videosurveillance",
    icon: "ShieldCheck",
    fr: {
      title: "Vidéosurveillance et sécurité connectée",
      short: "Solutions de vidéosurveillance, contrôle à distance et sécurité réseau destinées aux particuliers, entreprises, institutions et organisations publiques.",
      outcome: "Des sites surveillés et des réseaux protégés, pilotables à distance.",
      overview: "Nous intégrons des solutions de vidéosurveillance et de sécurité adaptées aux résidences, entreprises, sites industriels, institutions et espaces publics.",
      capabilities: [
        "Caméras IP", "Visualisation à distance", "Supervision centralisée",
        "Enregistrement sécurisé", "Intégration au contrôle d'accès",
        "Sécurité réseau", "Pare-feu", "IDS et IPS",
        "Connectivité administrée pour sites de surveillance",
      ],
      useCases: ["Surveiller un site industriel", "Protéger un commerce ou une résidence", "Centraliser la vidéosurveillance d'une institution"],
      segments: ["Particuliers", "Entreprises", "Institutions", "Espaces publics"],
      benefits: ["Pilotage à distance", "Enregistrement fiable", "Intégration réseau", "Évolutivité"],
      faq: [
        { q: "Proposez-vous la reconnaissance faciale ?", a: "Nous ne proposons de telles fonctionnalités que lorsqu'elles sont spécifiquement configurées et légalement autorisées." },
      ],
    },
    en: {
      title: "Video surveillance and connected security",
      short: "Video surveillance, remote monitoring and network security solutions for households, businesses, institutions and public organisations.",
      outcome: "Monitored sites and protected networks, manageable remotely.",
      overview: "We integrate video surveillance and security solutions suited to residences, businesses, industrial sites, institutions and public spaces.",
      capabilities: [
        "IP cameras", "Remote viewing", "Central monitoring",
        "Secure recording", "Access-control integration",
        "Network security", "Firewall", "IDS and IPS",
        "Managed connectivity for surveillance sites",
      ],
      useCases: ["Monitor an industrial site", "Protect a shop or residence", "Centralise an institution's video surveillance"],
      segments: ["Households", "Businesses", "Institutions", "Public spaces"],
      benefits: ["Remote control", "Reliable recording", "Network integration", "Scalability"],
      faq: [
        { q: "Do you offer facial recognition?", a: "We only offer such features when specifically configured and legally approved." },
      ],
    },
  },
  {
    slug: "genie-civil-fibre",
    icon: "HardHat",
    fr: {
      title: "Génie civil et déploiement de réseaux fibre",
      short: "Étude, conception, installation, essais et maintenance d'infrastructures fibre optique — de réseaux locaux à des dorsales de plusieurs centaines de kilomètres.",
      outcome: "Une infrastructure fibre livrée dans les règles de l'art, documentée et maintenable.",
      overview: "Nos équipes assurent l'étude, la conception, l'installation, les essais et la maintenance des infrastructures fibre optique. Notre expérience comprend des projets FTTx, des réseaux métropolitains et des dorsales de longue distance — des réseaux locaux à des dorsales pouvant atteindre plusieurs centaines de kilomètres.",
      capabilities: [
        "Relevés de site", "Conception de tracés", "Tranchées et pose de fourreaux",
        "Fibre aérienne et enterrée", "Chambres et regards", "Tirage et soufflage de câbles",
        "Soudure par fusion", "Tests et certification", "Documentation et plans DOE",
        "Maintenance préventive et corrective",
      ],
      useCases: ["Construire une dorsale régionale", "Câbler un nouveau quartier", "Reprendre et certifier un réseau existant"],
      segments: ["Opérateurs", "Promoteurs", "Secteur public", "Grands projets"],
      benefits: ["Équipes terrain expérimentées", "Documentation complète", "Standards internationaux", "Maintenance assurée"],
      faq: [
        { q: "Intervenez-vous hors de Kinshasa ?", a: "Oui, nos équipes interviennent sur des projets en RDC et, selon les partenariats, dans d'autres marchés africains." },
      ],
    },
    en: {
      title: "Civil engineering and fibre network deployment",
      short: "Survey, design, installation, testing and maintenance of fibre-optic infrastructure — from local networks to backbones of several hundred kilometres.",
      outcome: "Fibre infrastructure delivered to professional standards, documented and maintainable.",
      overview: "Our teams handle the survey, design, installation, testing and maintenance of fibre-optic infrastructure. Our experience spans FTTx projects, metropolitan networks and long-distance backbones — from local networks to backbones of up to several hundred kilometres.",
      capabilities: [
        "Site surveys", "Route design", "Trenching and duct deployment",
        "Aerial and underground fibre", "Chambers and handholes", "Cable pulling and blowing",
        "Fusion splicing", "Testing and certification", "Documentation and as-built plans",
        "Preventive and corrective maintenance",
      ],
      useCases: ["Build a regional backbone", "Cable a new district", "Take over and certify an existing network"],
      segments: ["Operators", "Developers", "Public sector", "Major projects"],
      benefits: ["Experienced field teams", "Complete documentation", "International standards", "Assured maintenance"],
      faq: [
        { q: "Do you operate outside Kinshasa?", a: "Yes, our teams work on projects across the DRC and, through partnerships, in other African markets." },
      ],
    },
  },
  {
    slug: "reseaux-prives-fibre-noire",
    icon: "Lock",
    fr: {
      title: "Réseaux privés et fibre noire",
      short: "Infrastructures fibre dédiées pour opérateurs, entreprises, banques, institutions, campus, centres de données et projets stratégiques exigeant contrôle, capacité et confidentialité.",
      outcome: "Un réseau dédié, sous votre contrôle, dimensionné pour vos usages les plus exigeants.",
      overview: "Nous concevons des infrastructures fibre dédiées pour les opérateurs, entreprises, banques, institutions, campus, centres de données et projets stratégiques nécessitant contrôle, capacité et confidentialité.",
      capabilities: [
        "Fibre noire (dark fibre) dédiée", "Réseaux privés campus et inter-sites",
        "Liaisons centres de données", "Architecture sur mesure",
        "Contrats long terme", "Maintenance dédiée",
      ],
      useCases: ["Interconnecter deux centres de données", "Doter une banque d'un réseau privé", "Sécuriser les communications d'une institution"],
      segments: ["Opérateurs", "Banques", "Institutions", "Centres de données"],
      benefits: ["Contrôle total", "Capacité sans partage", "Confidentialité", "Évolutivité long terme"],
      faq: [
        { q: "Qu'est-ce que la fibre noire ?", a: "Une infrastructure fibre dédiée, non éclairée par l'opérateur : vous contrôlez l'équipement et la capacité." },
      ],
    },
    en: {
      title: "Private networks and dark fibre",
      short: "Dedicated fibre infrastructure for operators, enterprises, banks, institutions, campuses, data centres and strategic projects requiring control, capacity and confidentiality.",
      outcome: "A dedicated network under your control, sized for your most demanding uses.",
      overview: "We design dedicated fibre infrastructure for operators, enterprises, banks, institutions, campuses, data centres and strategic projects requiring control, capacity and confidentiality.",
      capabilities: [
        "Dedicated dark fibre", "Private campus and inter-site networks",
        "Data-centre links", "Custom architecture",
        "Long-term contracts", "Dedicated maintenance",
      ],
      useCases: ["Interconnect two data centres", "Give a bank its own private network", "Secure an institution's communications"],
      segments: ["Operators", "Banks", "Institutions", "Data centres"],
      benefits: ["Full control", "Unshared capacity", "Confidentiality", "Long-term scalability"],
      faq: [
        { q: "What is dark fibre?", a: "Dedicated fibre infrastructure not lit by the operator: you control the equipment and the capacity." },
      ],
    },
  },
];

export const solutionBySlug = (slug) => SOLUTIONS.find((s) => s.slug === slug);
